/**************************************************
 * Nombre:       Formulario_Sectores_Config
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ZoomInMapOutlined, Flag, UpgradeOutlined, TableRestaurantOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSMESASCONFIG} from "../../Constantes";

const Formulario_Sectores_Config = ({...props}) => {



    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={6}>
                    <IngresoTexto Icono={ZoomInMapOutlined} nombre={'Nombre Sector'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={UpgradeOutlined} nombre={'Prioridad'} dato={'prioridad'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>





            </Grid>

        </form>

    )

}
export default Formulario_Sectores_Config